import { Swiper, Navigation, Pagination, Autoplay, Thumbs } from 'swiper'
import { breakpointDown, breakpointUp } from '../utils/breakpoints'

Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

if (breakpointDown('md')) {

  let newsSliderEl = $('.js-resp-news-slider')
  let newsSliderCurSlideEl = $('.js-news-cur-slide')

  if (newsSliderEl.length) {

    const newsSlider = new Swiper('.js-resp-news-slider', {
      loop: true,
      // autoplay: {
      //   delay: 3000,
      //   pauseOnMouseEnter: true,
      //   disableOnInteraction: true
      // },
      //speed: 800,
      navigation: {
        nextEl: '.js-news-next',
        prevEl: '.js-news-prev',
      },
      on: {
        slideChange: function () {
          newsSliderCurSlideEl.text(this.realIndex + 1)
        }
      }

    });

  }



}


export function initGallerySlider(container){
  let galleries = container.find('.js-gallery-slider-block')

  galleries.each(function(){
    let sliderNav = $(this).find('.js-gallery-slider-nav')
    let slider = $(this).find('.js-gallery-slider')

    // gallery slider
    let gallerySliderNav = new Swiper(sliderNav[0], {
      loop: true,
      slidesPerView: 10,
      freeMode: true,
      watchSlidesProgress: true,
    });
    let gallerySlider = new Swiper(slider[0], {
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: gallerySliderNav,
      },
    });


  })

}

if ($('.single-post-content').length){
  initGallerySlider($('.post-popup-content'))
}
